'use client'

import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Picture } from '@/ui/media/picture/Picture.client'
import { generatePictureSource } from '@/ui/media/picture/Picture.service'
import { Title } from '@/ui/text/title/Title'
import { gql } from '@gql-generated/gql'
import type { ProductLabels_ProductFragment } from '@gql-generated/graphql'

gql(/* GraphQL */ `
  fragment ProductLabels_Product on Product {
    hasRseLabel
  }
`)

const PRODUCT_LABELS = [
  {
    src: '/media/image/rse/common/logo-rse-fr.svg', // TODO: dynamise source if NL or ES get this data one day
    altKey: 'productPage:labels.rse.alt',
    isVisible: (product: ProductLabels_ProductFragment) => product.hasRseLabel === true,
  },
] as const

export function hasProductLabels(product: ProductLabels_ProductFragment): boolean {
  const labels = PRODUCT_LABELS.filter((label) => label.isVisible(product))

  return labels.length > 0
}

export type ProductLabelsProps = {
  // The product carrying the label flags
  product: ProductLabels_ProductFragment
}

export function ProductLabels({ product }: ProductLabelsProps): React.ReactElement {
  const { t } = useTranslation(['productPage'])

  const labels = PRODUCT_LABELS.filter((label) => label.isVisible(product))

  return (
    <>
      <Title size="2xl" as="h2" className="font-bold">
        {t('productPage:labels.title')}
      </Title>
      <div className="flex flex-wrap gap-2">
        {labels.map((label) => (
          <Picture
            key={label.altKey}
            image={generatePictureSource({ mobileUrl: label.src, alt: t(label.altKey) })}
            mode="contain"
            width="80"
            height="80"
            pictureClassName="flex size-10 items-center justify-center"
            className="max-h-full max-w-full"
          />
        ))}
      </div>
    </>
  )
}
